import { useState } from "react";
import { Img, DemoAction } from "./shared";

const PROJECTS = [
  { k: "arch1", t: "Haus am Hang", y: "2024", m: "Wohnbau · Sichtbeton" },
  { k: "arch3", t: "Atelier Nord", y: "2023", m: "Bürobau · Holz-Alu" },
  { k: "arch2", t: "Fassade 12", y: "2023", m: "Sanierung · Relief" },
  { k: "arch4", t: "Pavillon Ost", y: "2022", m: "Kultur · Beton" },
];

export default function Architektur({ wide, onCta }) {
  const [i, setI] = useState(0);
  const p = PROJECTS[i];
  return (
    <div className="bg-[#F2F1EE] text-[#151515]" style={{ fontFamily: "'Syne Variable', sans-serif" }}>
      <header className="flex items-center justify-between px-5 pt-12 pb-4 text-[11px] uppercase tracking-[0.25em]" style={wide ? { paddingTop: 28, paddingLeft: 48, paddingRight: 48 } : undefined}>
        <span className="font-bold">Studio Kante</span>
        <span className="text-[#555]">Projekte · Büro · Kontakt</span>
      </header>
      <section className={wide ? "grid grid-cols-12 gap-6 px-12 pt-10 pb-16" : "px-5 pt-6 pb-10"}>
        <h1 className={wide ? "col-span-5 self-end text-[64px] font-semibold leading-[0.95] tracking-tight" : "text-[40px] font-semibold leading-[0.95] tracking-tight"}>
          Räume,<br />die bleiben.
        </h1>
        <div className={wide ? "col-span-7 aspect-[4/3] overflow-hidden" : "mt-6 aspect-[4/5] overflow-hidden"}>
          <Img k="arch1" alt="Sichtbetonbau am Hang" />
        </div>
        <p className={wide ? "col-span-4 col-start-2 text-[15px] leading-relaxed text-[#444]" : "mt-5 text-[14px] leading-relaxed text-[#444]"}>
          Architektur für Wohnen, Arbeit und Kultur. Präzise geplant, ruhig im Ausdruck.
        </p>
      </section>
      <section className={wide ? "px-12 pb-16" : "px-5 pb-10"}>
        <div className="flex items-baseline justify-between border-t border-[#151515] pt-3 text-[11px] uppercase tracking-[0.2em]">
          <span>Projektgalerie</span><span>{String(i + 1).padStart(2, "0")} / 04</span>
        </div>
        <div className={wide ? "mt-6 grid grid-cols-12 gap-6" : "mt-4"}>
          <div className={wide ? "col-span-8 aspect-[16/10] overflow-hidden" : "aspect-square overflow-hidden"}>
            <Img k={p.k} alt={p.t} className="transition-opacity duration-500" />
          </div>
          <div className={wide ? "col-span-4 flex flex-col justify-between" : "mt-4"}>
            <div>
              <h2 className="text-[26px] font-semibold leading-tight">{p.t}</h2>
              <p className="mt-1 text-[13px] text-[#555]">{p.m} · {p.y}</p>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-2">
              {PROJECTS.map((x, j) => (
                <button key={x.k} type="button" data-noswipe aria-label={`Projekt ${x.t} anzeigen`} onClick={() => setI(j)}
                  className={`aspect-square overflow-hidden transition-opacity ${j === i ? "opacity-100 ring-2 ring-[#151515] ring-offset-2 ring-offset-[#F2F1EE]" : "opacity-50"}`}>
                  <Img k={x.k} />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={wide ? "grid grid-cols-2 gap-6 px-12 pb-16" : "grid grid-cols-2 gap-3 px-5 pb-10"}>
        <div className="aspect-[3/4] overflow-hidden"><Img k="arch3" /></div>
        <div className="flex flex-col justify-end text-[13px] leading-relaxed text-[#444]">
          <span className="text-[44px] font-semibold leading-none text-[#151515]">18</span>
          Jahre Erfahrung mit Wohn- und Kulturbauten. <em>(fiktiv)</em>
        </div>
      </section>
      <footer className={wide ? "px-12 pb-14" : "px-5 pb-12"}>
        <DemoAction label="Projekt anfragen →" onCta={onCta} className="border-b border-[#151515] pb-1 text-[15px] font-semibold" />
      </footer>
    </div>
  );
}
